import React, { Component } from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Table from 'react-bootstrap/Table';
import Collapsible from 'react-collapsible';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import { connect } from 'react-redux';
// style
import s from './ViewBookingTransactionDetails.css';
import rs from '../../../restaurantCommon.css';
// helpers
import messages from '../../../../locale/messages';
// components
import CurrencyConverter from '../../../CurrencyConverter';

export class ViewRefundAccordion extends Component {
    static defaultProps = {
        data: []
    }

    constructor(props) {
        super(props);
        this.renderRefundHistory = this.renderRefundHistory.bind(this);
    }

    renderRefundHistory(data, requestType) {
        const { formatMessage } = this.props.intl;
        let tableHeaders = [messages.amount, messages.date, messages.refundIdLabel, messages.remarks];
        tableHeaders = requestType === 'failed' ? [messages.amount, messages.date, messages.transactionIdLabel, messages.remarks, messages.errorRemarks] : tableHeaders;

        return (
            <Table size="sm">
                <thead>
                    <tr>
                        {
                            tableHeaders.map((header, index) => {
                                return (
                                    <th scope="col" key={index}>{formatMessage(header)}</th>
                                )
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        data && data.length > 0 && data.map((item, key) => {
                            return (
                                <tr>
                                    <td data-label={formatMessage(messages.amount)}><CurrencyConverter from={item.currency} amount={item.amount} /></td>
                                    <td data-label={formatMessage(messages.date)}>{moment(item.createdAt).format('MM-DD-YYYY hh:mm:ss a')}</td>
                                    {
                                        requestType !== 'failed' && <td data-label={formatMessage(messages.refundIdLabel)}>{item.refundId ? item.refundId : '-'}</td>
                                    }
                                    {
                                        requestType === 'failed' && <td data-label={formatMessage(messages.transactionIdLabel)}>{item.transactionId ? item.transactionId : '-'}</td>
                                    }
                                    <td data-label={formatMessage(messages.remarks)}>{requestType !== 'failed' ? item.refundNotes : item.notes}</td>
                                    {
                                        requestType === 'failed' && <td data-label={formatMessage(messages.errorRemarks)}>{item.errorRemarks}</td>
                                    }
                                </tr>
                            )
                        })
                    }
                    {
                        (data && data.length === 0 || !data) && <tr className={'text-center'}>
                            <td colSpan={50}>
                                <FormattedMessage {...messages.noResult} />
                            </td>
                        </tr>
                    }
                </tbody>
            </Table>
        )
    }

    render() {
        const { headerText, data, requestType } = this.props;

        return (
            <div className={cx(rs.space2)}>
                <Collapsible trigger={headerText}>
                    <div className={cx('NewAdminResponsiveTable', rs.spaceTop2)}>
                        {this.renderRefundHistory(data, requestType)}
                    </div>
                </Collapsible>
            </div>
        );
    }
}

const mapState = state => ({
    locale: state.intl.locale
});
const mapDispatch = {};

export default injectIntl(withStyles(s, rs)(connect(mapState, mapDispatch)(ViewRefundAccordion)));